<template>
    <div class="roundbox">
        <div class="rbcontent head">
            <div>
                <slot name="commands"></slot>
                <h2>{{header}}</h2>
            </div>
        </div>
        <slot name="tabs"></slot>
        <form :class="{loading:loading}" v-on:submit.prevent="submit">
            <fieldset :disabled="disabled || loading || !isLicenceActive">
                <div class="rbcontent form" :style="formStyle">
                        <slot></slot>
                </div>
                <div class="rbcontent footer">
                    <slot name="footer"></slot>
                </div>
            </fieldset>
        </form>
    </div>
</template>

<script> 
export default {
    props: {
        disabled:Boolean,
        loading: Boolean,
        header: String,
        formStyle: Object
        //showClearButton: Boolean
    },
    computed: {
        isLicenceActive(){
            return true;
            //return this.$root.$data.login.Account.IsLicenceActive;
        }
    },
    methods:{
        submit($event) {
            this.$emit('save', $event);
        }
    }
}
</script>
<style scoped>
    .loading {
        opacity: 0.5;
    }
</style>